import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  WritableSignal,
  computed,
  inject,
  model,
  signal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SignalsStoreService } from '../../signals-store.service';
import { formatCurrency, formatCurrencyToAmount } from '../../utils/formatting';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { OrderService } from '../../order.service';
import { ResolutionService } from '../../resolution.service';
import { CurrencyInputDirective } from '../../directives/currency-input.directive';
import { TipOptions } from '../../types/common.enums';
import { NotificationService } from '../../notification/notification.service';
import { EmptyMessageComponent } from '../../empty-message/empty-message.component';

@Component({
  selector: 'app-donation',
  imports: [
    MatRadioModule,
    CommonModule,
    FormsModule,
    MatCheckboxModule,
    CurrencyInputDirective,
    EmptyMessageComponent
  ],
  templateUrl: './donation.component.html',
  styleUrl: './donation.component.scss'
})
export class DonationComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private signalsStoreService = inject(SignalsStoreService);
  private orderService = inject(OrderService);
  private resolutionService = inject(ResolutionService);
  private notificationService = inject(NotificationService);

  recurrentType = TipOptions.RECURRENT;
  oneTimeType = TipOptions.ONE_TIME;
  recurrentAmount = model('');
  oneTimeAmount = model('');
  selectedOption: WritableSignal<string> = signal('');
  showApplyToAll: WritableSignal<boolean> = signal(false);
  applyToAllOrders: WritableSignal<boolean> = signal(false);
  isMobile = computed(() => this.resolutionService.isMobile());
  donationDisclaimer = `<strong>Please note:</strong> One-time or recurring donations at checkout are only processed with orders that meet the $25 product minimum. If you’d like to donate without placing an order, you can use the floating <strong>Donate</strong> button anytime.`

  ngOnInit() {
    const donation = this.orderService.odooOrder()?.paymentDetails.donation;
    if (donation?.amount) {
      this.showApplyToAll.set(true)
      this.selectedOption.set(donation?.isRecurrent ? 'RECURRENT' : 'ONE_TIME');
      if (donation?.isRecurrent) {
        this.recurrentAmount.set(formatCurrency(
          donation?.amount ||
          this.signalsStoreService.odooDonationAmountVoluntary()
        ));
      } else {
        this.oneTimeAmount.set(formatCurrency(donation?.amount));
      }
    }
  }

  donate() {

    const isRecurrent = this.selectedOption() === this.recurrentType;

    let amount = 0;
    let value = (document.getElementById(isRecurrent ? 'recurrent-amount' : 'one-time-amount') as HTMLInputElement)?.value || '';

    if (!value) {
      return this.notificationService.show({
        text: 'Please enter a valid amount',
        type: 'error'
      });
    }

    if (value && value.endsWith('.'))
      value = value.slice(0, -1);

    const parts = value.split('.');

    if (parts.length === 1)
      value += '.00';
    else if (parts[1].length === 1)
      value += '0';

    amount = formatCurrencyToAmount(value);

    if (!amount) {
      return this.notificationService.show({
        text: 'Please enter a valid amount',
        type: 'error',
      });
    }

    this.activeModal.close({
      isRecurrent,
      amount,
      applyToAllOrders: this.applyToAllOrders()
    });
  }

  closeModal() {
    this.activeModal.close();
  }
}
